import script from "./Qrcode.vue?vue&type=script&setup=true&lang=js"
export * from "./Qrcode.vue?vue&type=script&setup=true&lang=js"

import "./Qrcode.vue?vue&type=style&index=0&id=28dc924d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28dc924d"]])

export default __exports__